module.exports = __webpack_public_path__ + "img/a750a5d.png";